import { gql } from "@apollo/client"
import { makeBusyFunction } from "lib/@components/busy/make-busy-function"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const createDataExportRequestEmail = makeBusyFunction(
    api(async function createDataExportRequestEmail(request) {
        const { name, email, dataExportType, reason } = request
        return mutate(
            gql`
                mutation CreateDataExportRequestEmail(
                    $name: String!
                    $email: String!
                    $dataExportType: String!
                    $reason: String!
                ) {
                    createDataExportRequestEmail(
                        name: $name
                        email: $email
                        dataExportType: $dataExportType
                        reason: $reason
                    )
                }
            `,
            { name, email, dataExportType, reason },
            { returns: "createDataExportRequestEmail" }
        )
    }),
    "Sending Data Export Request"
)
